import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import * as styles from './Modal.scss';

var Modal = /*#__PURE__*/function (_React$Component) {
  _inherits(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "update", function (previousOpenState) {
      var open = _this.props.open;
      var transitionOpenValue = _this.state.transitionOpenValue;

      if (previousOpenState !== open && !!open === false) {
        setTimeout(function () {
          _this.setState({
            transitionOpenValue: false
          });
        }, 500);
      }

      if (!!open === true && transitionOpenValue === false) {
        _this.setState({
          transitionOpenValue: true
        });
      }
    });

    _this.state = {
      transitionOpenValue: !!props.open || false
    };
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.update(this.state.transitionOpenValue);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _ref) {
      var transitionOpenValue = _ref.transitionOpenValue;
      this.update(transitionOpenValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$actions = _this$props.actions,
          actions = _this$props$actions === void 0 ? null : _this$props$actions,
          children = _this$props.children,
          _this$props$childModa = _this$props.childModal,
          childModal = _this$props$childModa === void 0 ? false : _this$props$childModa,
          _this$props$leftActio = _this$props.leftActions,
          leftActions = _this$props$leftActio === void 0 ? null : _this$props$leftActio,
          _this$props$modal = _this$props.modal,
          modal = _this$props$modal === void 0 ? false : _this$props$modal,
          open = _this$props.open,
          onRequestClose = _this$props.onRequestClose,
          _this$props$padding = _this$props.padding,
          padding = _this$props$padding === void 0 ? '16px' : _this$props$padding,
          _this$props$showClose = _this$props.showCloseBtn,
          showCloseBtn = _this$props$showClose === void 0 ? true : _this$props$showClose,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? null : _this$props$style,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$titleStyl = _this$props.titleStyle,
          titleStyle = _this$props$titleStyl === void 0 ? null : _this$props$titleStyl;
      var transitionOpenValue = this.state.transitionOpenValue;
      var openBool = !!open;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !childModal && /*#__PURE__*/React.createElement("div", {
        id: "test-modaloverlay",
        className: "".concat(styles.overlay, " ").concat(openBool ? styles.active : ''),
        onClick: modal ? function () {
          return true;
        } : onRequestClose
      }), /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.modal, " ").concat(openBool ? styles.active : ''),
        style: style ? style : {}
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.titleRow,
        style: title ? {
          borderBottom: '1px solid #dddddd'
        } : {}
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.title,
        style: titleStyle ? titleStyle : {}
      }, title), showCloseBtn && onRequestClose && /*#__PURE__*/React.createElement("button", {
        id: "test-closebtn",
        className: styles.closeBtn,
        onClick: onRequestClose
      }, "\xD7")), /*#__PURE__*/React.createElement("div", {
        id: "test-modalbody",
        "data-modalopen": "".concat(openBool),
        className: styles.modalContent,
        style: actions ? {
          marginBottom: 55,
          padding: padding
        } : {
          padding: padding
        }
      }, transitionOpenValue && children), actions && /*#__PURE__*/React.createElement("div", {
        id: "test-buttonwrap",
        className: styles.buttonWrap
      }, /*#__PURE__*/React.createElement("div", {
        id: "test-leftactions",
        className: styles.leftActions
      }, leftActions), /*#__PURE__*/React.createElement("div", {
        id: "test-rightactions",
        className: styles.rightActions
      }, actions))));
    }
  }]);

  return Modal;
}(React.Component);

export { Modal as default };